'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AppStoreBadge;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _SpacerElement = require('../../internal/SpacerElement');

var _SpacerElement2 = _interopRequireDefault(_SpacerElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  'wrapper': 'ccl-9515d92382999d48',
  'badge': 'ccl-f90a9461a8351bfb',
  'ios': 'ccl-ed1ef21fd5589187',
  'android': 'ccl-4f679b4f054d4574'
};

/**
 * Android and iOS app badges to promote our app.
 */

function AppStoreBadge(props) {
  return _react2.default.createElement(
    _SpacerElement2.default,
    {
      element: 'span',
      className: styles.wrapper,
      spacing: props.spacing,
      adjacentVerticalSpacing: props.adjacentVerticalSpacing,
      adjacentHorizontalSpacing: props.adjacentHorizontalSpacing
    },
    _react2.default.createElement(
      'span',
      { className: (0, _classnames2.default)(styles.badge, styles[props.type]) },
      props.text
    )
  );
}

AppStoreBadge.displayName = 'AppStoreBadge';
AppStoreBadge.propTypes = _extends({
  /**
   * The type of app store you'd like to show.
   */
  type: _propTypes2.default.oneOf(['ios', 'android']),

  /**
   * The text which should be included in the markup of this component for
   * screen-readers.
   */
  text: _propTypes2.default.string.isRequired
}, _SpacerElement2.default.propTypes);

AppStoreBadge.defaultProps = _extends({
  type: 'ios'
}, _SpacerElement2.default.defaultProps);